/* eslint-disable max-len */
import {
  Component,
  OnInit,
  ViewChild,
  ChangeDetectorRef,
  AfterContentChecked,
  Inject,
  OnDestroy,
  ElementRef,
} from '@angular/core';
import {
  filter,
  debounceTime,
  distinctUntilChanged,
  map,
  switchMap,
  first,
  takeUntil,
  Subject,
} from 'rxjs';
import { FaqsService } from 'src/app/core/services/faqs-service/faqs.service';
import {
  EquisDropdownTypes,
  EquisDropdownWidth,
  EquisDropdownDisplay,
  EquisDropdownDirective,
} from '@tn-equis/core/components/dropdown';
import { FormControl, Validators } from '@angular/forms';
import { TEXTS_VARIABLE } from '../../constants/constants-texts';
import { DOCUMENT } from '@angular/common';
import { Router } from '@angular/router';
import { EquisNavigatorService } from '@tn-equis/core/services';

@Component({
  selector: 'app-searchbar',
  templateUrl: './searchbar.component.html',
  styleUrls: ['./searchbar.component.scss'],
})
export class SearchbarComponent
  implements OnInit, OnDestroy, AfterContentChecked
{
  data: any = {};
  showTitle: boolean = false;
  texts = TEXTS_VARIABLE;
  queryFormControl: FormControl = new FormControl('', Validators.required);
  loading = false;
  isMobile;
  _suggestions: Array<any> = [];
  iconX = false;
  dropdownData = {
    dropdownDirection: EquisDropdownDisplay.BOTTOM_RIGHT,
    dropdownWidth: 0,
    marginTop: 20,
    marginSide: 0,
    widthType: EquisDropdownWidth.PIXELS,
    closeOnClick: true,
  };
  private destroyed$ = new Subject<void>();
  private stringLengthToSearch = 3;

  @ViewChild(EquisDropdownDirective)
  equisDropdown: EquisDropdownDirective | undefined;

  @ViewChild('searchInput')
  searchInput!: ElementRef;

  constructor(
    @Inject(DOCUMENT) private doc: Document,
    private router: Router,
    private faqsService: FaqsService,
    private equisNavigatorService: EquisNavigatorService,
    private changeDetector: ChangeDetectorRef,
  ) {
    this.isMobile = this.equisNavigatorService.isMobile;
  }

  ngOnInit(): void {
    this.faqsService
      .getSearchData()
      .pipe(first())
      .subscribe(
        searchData => (this.data = { ...searchData[0], ...this.data }),
      );

    this.faqsService._showTitleSearchComponent$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(
        res => ((this.showTitle = res), this.changeDetector.detectChanges()),
      );
    const element = document.querySelector(
      'equis-textfield div.textfield div.textfield__input-line ',
    );

    if (element) {
      // eslint-disable-next-line max-len, max-len
      var newElement = `<div id="equis-icon" class="textfield__left-addons"><div clas="textfield__icon-addon icon textfield-base-icon"><img class='margin-left-8' src='assets/icons/icon-magnifier.svg'/></div></div>`;
      element!.insertAdjacentHTML('afterbegin', newElement);
    }

    //Cuando detecta un input, muestra el icono de X
    this.queryFormControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$),
        map(q => q as string),
        filter(q => q?.length >= 1),
      )
      .subscribe(() => {
        this.iconX = true;
      });

    this.queryFormControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$),
        map((q: string) => q),
        debounceTime(500),
        distinctUntilChanged(),
        filter(
          (q: any) =>
            q &&
            (q as string).length >= this.stringLengthToSearch &&
            (q as string) !== '',
        ),
        switchMap(q => {
          this.loading = true;
          return this.faqsService.autocomplete(q as string);
        }),
      )
      .subscribe(suggestionsQuery => {
        const query = this.queryFormControl.value;
        if (
          !(query === '' || query.length === 0) &&
          !(suggestionsQuery.length === 0)
        ) {
          this.cleanSuggestions();
          (suggestionsQuery as string[]).map(s =>
            this._suggestions.push({
              optionList: [
                {
                  text: s,
                  type: EquisDropdownTypes.TEXT,
                  hover: true,
                },
              ],
            }),
          );
          this.searchInput.nativeElement.click();
        } else {
          this.cleanSuggestions();
        }
        this.loading = false;
      });

    this.queryFormControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$),
        map(q => q as string),
        filter(q => q === '' || q?.length < this.stringLengthToSearch),
      )
      .subscribe(() => {
        this.cleanSuggestions();
      });
  }

  ngAfterContentChecked(): void {
    this.dropdownData.dropdownWidth = (
      this.doc.getElementsByClassName('textfield')[0] as HTMLDivElement
    )?.offsetWidth;
  }

  searchFAQs(): void {
    if (this.queryFormControl.valid) {
      this.loading = true;
      const query = this.queryFormControl.value;
      this.queryFormControl.setValue(query);

      const params = {
        q: query,
      };

      this.router
        .navigate([`busqueda/${params.q}`], { queryParamsHandling: 'preserve' })
        .then(() => {
          this.loading = false;
          this.equisDropdown!.hide();
          this.searchInput.nativeElement.blur();
        });
    }
  }

  onSuggestionClick(event: any): void {
    const query = event.objectEmitted;
    this.loading = true;
    this.queryFormControl.setValue(query, { emitEvent: false });

    const params = {
      q: query,
    };
    this.router
      .navigate([`busqueda/${params.q}`], { queryParamsHandling: 'preserve' })
      .then(() => {
        this.loading = false;
      });
  }

  cleanSuggestions(): void {
    const count = this._suggestions.length;
    this._suggestions.splice(0, count);
    this.equisDropdown?.hide();
  }

  clearInput(): void {
    this.queryFormControl.reset();
    this.hideIcon();
  }

  showIcon(): void {
    if (this.queryFormControl.value > 1) {
      this.iconX = true;
    }
  }

  hideIcon(): void {
    if (this.queryFormControl.value < 1) {
      this.iconX = false;
    }
  }

  ngOnDestroy(): void {
    this.destroyed$?.next();
    this.destroyed$?.complete();
  }
}
